"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _VideoInputChooser = require("./VideoInputChooser");
Object.keys(_VideoInputChooser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VideoInputChooser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoInputChooser[key];
    }
  });
});